import React from 'react'
import { Container, Row, Button } from "reactstrap";
import SelectFiltro from '../../comum/components/SelectFiltro';
import Card from '../../comum/components/Card';

import desovaPierService from "../../../services/DesovaPierService";
import FormDatePicker from '../../comum/components/FormDatePicker';
import CheckboxField from '../../comum/components/CheckboxField';
import Tooltip from '../../comum/components/Tooltip';
import { normalizarString } from '../../../utils/functions'
import FormInputSimples from '../../comum/components/FormInputSimples';

export default function Filtros({ filtrar, filtro, setFiltro, hasFilter }) {

    const handleChangeOperacaoPesquisa = event => {
        const operacao = event ? event.value : '';
        setFiltro({ operacao });
    }

    const handleChangeTipoPesquisa = event => {
        const tipo = event ? event.value : 0;
        setFiltro({ tipo });
    }
    const handleChangeContainerPesquisa = container => setFiltro({ container });

    const handleChangeBLPesquisa = newValue => {
        if (typeof(newValue) === 'string') {
            const bl = normalizarString(newValue).replace(' ','');
            setFiltro({ bl })
        } else {
            setFiltro({ bl: '' })
        }
    }

    const handleChangeDataInicialPesquisa = newDate => setFiltro({ dataInicial: newDate ? newDate.split('T')[0] : '' })

    const handleChangeDataFinalPesquisa = newDate => {
        if (newDate) {
            const formatedDate = new Date(newDate)
            formatedDate.setDate(formatedDate.getDate() + 1);
            const dataFinal = formatedDate.toISOString().split('T')[0]
            setFiltro({ dataFinal })
        } else {
            setFiltro({ dataFinal: '' })
        }
    }

    const handleChangeFilterSolicitantePesquisa = filterSolicitante => setFiltro({ filterSolicitante })

    const [combos, setCombos] = React.useState({
        operacoes: [{ Id: 'XXX', Texto: 'Nome da Operação' }],
        tipoPedido: [
            { Id: 0, Texto: 'Todos' },
            { Id: 1, Texto: 'Solicitado' },
            { Id: 2, Texto: 'Enviado P/Desova' },
            { Id: 3, Texto: 'Atendido' },
            { Id: 4, Texto: 'Cancelado' }
        ]
    })

    React.useEffect(() => {
        let isMounted = true;
        desovaPierService.obterOperacoes().then(({data}) => {
            if (isMounted && data) {
              const operacoes = data.map(x => {
                  return {
                      Id: x.Viagem,
                      Texto: `${x.Viagem} - ${x.Navio}`
                  };
              });
              setCombos(combos => ({ ...combos, operacoes }))
          };
        })
        return () => { isMounted = false };
      }, []);     

    
    return (
        <div className="form-wrapper">
            <Container fluid>
                <Card className="tabela-container area-form pb-0">
                    <Row className="align-items-end">
                        <SelectFiltro
                            xl={3} lg={4} md={6} sm={12} xs={12}
                            titulo="Operação"
                            itens={combos.operacoes}
                            value={filtro.operacao}
                            itensValor="Id" itensLabel="Texto"
                            onChange={(event) => handleChangeOperacaoPesquisa(event)}
                        />

                        <FormInputSimples
                            xl={2} lg={4} md={6} sm={12} xs={12}
                            titulo='Container'
                            inputClassName='input--uppercase'
                            onEnter={() => filtrar()}
                            value={filtro.container}
                            onChange={(event) => handleChangeContainerPesquisa(event.target.value)}
                        />

                        <FormInputSimples
                            xl={2} lg={4} md={6} sm={12} xs={12}
                            titulo='MBL'
                            inputClassName='input--uppercase'
                            onEnter={() => filtrar()}
                            value={filtro.bl}
                            onChange={(event) => handleChangeBLPesquisa(event.target.value)}
                        />

                        <SelectFiltro
                            xl={3} lg={4} md={6} sm={12} xs={12}
                            titulo="Situação"
                            itens={combos.tipoPedido}
                            value={filtro.tipo}
                            placeholder={"Todos"}
                            itensValor="Id" itensLabel="Texto"
                            onChange={(event) => handleChangeTipoPesquisa(event)}
                        />
                    </Row>
                    <Row>
                        <FormDatePicker
                            xl={2} lg={3} md={6} sm={12} xs={12}
                            titulo="Data Inicial"
                            uniqueId="dataInicial"
                            onChange={(date) => handleChangeDataInicialPesquisa(date)}
                            date={filtro.dataInicial}
                            showClearDate
                        />

                        <FormDatePicker
                            xl={2} lg={3} md={6} sm={12} xs={12}
                            titulo="Data Final"
                            uniqueId="dataFinal"
                            onChange={(date) => handleChangeDataFinalPesquisa(date)}
                            date={filtro.dataFinal}
                            showClearDate
                        />
                        
                        <CheckboxField 
                            className='mb-4 w-100s'
                            xl={3} lg={4} md={6} sm={12} xs={12}
                            text='Exibir minhas solicitações'
                            onClick={() => null}
                            ativo={filtro.filterSolicitante}
                            onChange={checked => handleChangeFilterSolicitantePesquisa(checked)}
                            backgroundWhite
                        />
                        
                    </Row>
                    <Row>
                        <Tooltip tooltipText={hasFilter ? 'Clique para filtrar' : 'Preencha pelo menos um filtro'}>
                            <Button
                                className="btn-com-bordas-primary btn-filtrar"
                                style={{ margin: '25px 10px' }}
                                onClick={() => filtrar()}
                                disabled={!hasFilter}
                            >
                                Filtrar
                            </Button>
                        </Tooltip>
                    </Row>
                </Card>
            </Container>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/modules/desova-pier/components/Filtros.js